import { types, flow } from 'mobx-state-tree';
import api from 'services/API';
import { HelpCenterCategory } from 'models/types/help-center';

export const helpCenterInitialState = {
  isLoaded: false,
  categories: [],
};

export const helpCenterModel = types
  .model({
    isLoaded: types.boolean,
    categories: types.array(HelpCenterCategory),
  })
  .views(self => ({
    get allCategories() {
      return self.categories.slice();
    },
  }))
  .actions(self => ({
    fetch: flow(function* (lang = 'en') {
      try {
        const response = yield api.getHelpCenterCategories(lang);
        if (response && response.data) {
          self.categories.replace(response.data.result);
        }
        self.isLoaded = true;
      } catch (err) {
        self.isLoaded = true;
        return Promise.reject(err);
      }
    }),
  }));
